import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

// Helpers para almacenamiento con expiración
const Storage = {
    setItem(key, value, expiry) {
        const data = { value, expiry };
        localStorage.setItem(key, JSON.stringify(data));
    },
    getItem(key) {
        const itemStr = localStorage.getItem(key);
        if (!itemStr) return null;

        const { value, expiry } = JSON.parse(itemStr);
        const now = dayjs();

        if (expiry && now.isAfter(dayjs(expiry))) {
            localStorage.removeItem(key);
            return null;
        }

        return value;
    },
    getExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        //console.log(`DEBUG getExpiry: no item for key ${key}`);
        return null;
    }

    try {
        const { expiry } = JSON.parse(itemStr);
        //console.log(`DEBUG getExpiry: expiry for key ${key} =`, expiry);
        return expiry ? dayjs(expiry).valueOf() : null;
    } catch(e) {
        console.error('DEBUG getExpiry: error parsing JSON', e);
        return null;
    }
    },

    removeItem(key) {
        localStorage.removeItem(key);
    }
};

function extractExpiryFromToken(token) {
    try {
        const parts = token.split('.');
        if (parts.length !== 3) return null;

        // Convertir base64url a base64 tradicional
        const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        // Decodificar Base64 a string JSON
        const jsonPayload = atob(base64);
        // Parsear JSON
        const payload = JSON.parse(jsonPayload);

        const exp = payload.exp;
        if (typeof exp === 'number') {
            return dayjs.unix(exp).valueOf();
        }
    } catch (err) {
        console.error('❌ Error parseando el token JWT:', err);
    }
    return null;
}



const state = {
  token: null,
  user: null,
  isAuthenticated: false
};

function loadStateFromStorage() {
  const tokenDataStr = localStorage.getItem('token');
  if (!tokenDataStr) return;

  try {
    const tokenData = JSON.parse(tokenDataStr);
    const token = tokenData.value;
    const expiry = tokenData.expiry;
    const now = dayjs();

    if (expiry && now.isAfter(dayjs(expiry))) {
      // Token expirado, limpiar
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      return;
    }

    state.token = token;
    state.user = JSON.parse(localStorage.getItem('user'))?.value || null;
    state.isAuthenticated = !!token;
  } catch (e) {
    // Si algo falla, borrar storage por seguridad
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }
}

loadStateFromStorage();

const mutations = {
setCredentials(state, { token, user }) {
    const expiry = extractExpiryFromToken(token);
    //console.log('DEBUG setCredentials - expiry extraído:', expiry, dayjs(expiry).format());

    state.token = token;
    state.user = user;
    state.isAuthenticated = true;

    Storage.setItem('token', token, expiry);
    Storage.setItem('user', user, expiry);
},

    clearCredentials(state) {
    state.token = '';
    state.user = null;
    state.isAuthenticated = false;
    Storage.removeItem('token');
    Storage.removeItem('user');
    }

};

const actions = {
    login({ commit }, { token, user }) {
        commit('setCredentials', { token, user });
    },
    logout({ commit }) {
        commit('clearCredentials');
    }
};



function getTokenExpiryFromJWT(token) {
  if (!token) return null;
  try {
    const base64Url = token.split('.')[1];
    const base64 = decodeURIComponent(atob(base64Url).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    const payload = JSON.parse(base64);
    return payload.exp ? dayjs.unix(payload.exp).valueOf() : null;
  } catch (e) {
    console.error("Error decodificando token JWT:", e);
    return null;
  }
}


const getters = {
    isAuthenticated: (state) => {
        return !!Storage.getItem('token') && state.isAuthenticated;
    },
    tokenExpiry: (state) => {
        return getTokenExpiryFromJWT(state.token);
    },

    user: (state) => state.user,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};